import React, {ReactElement} from 'react';
import classnames from 'classnames';
import {useDispatch} from 'react-redux';
import Select from '@frontend/ui-kit/Components/Select';
import {setLanguage} from '../../../actions/shared';
import translationService, {gettext, LANGUAGES} from '../../../translationService';
import {AppDispatch} from '../../../store';
import {LANGUAGE_OPTIONS} from '../../../options';
import iconUSAFlag from '../../../static/images/iconUSAFlag.svg';
import iconSpainFlag from '../../../static/images/iconSpainFlag.svg';
import './index.scss';

const ICONS_BY_LANGUAGE = {
    [LANGUAGES.en]: iconUSAFlag,
    [LANGUAGES.es]: iconSpainFlag
};

type Props = {
    className?: string;
};

const LanguageSelector = ({className}: Props): ReactElement => {
    const dispatch = useDispatch<AppDispatch>();

    const formatOptionLabel = ({value, label}) => (
        <div className='language-selector-option'>
            <div className='mr-3 language-selector-option__icon'>
                <img src={ICONS_BY_LANGUAGE[value]} alt={label}/>
            </div>
            <div className='language-selector-option__label'>{label}</div>
        </div>
    );

    const onChange = value => {
        dispatch(setLanguage(value));
    };

    return (
        <Select value={translationService.getLanguage()}
            options={LANGUAGE_OPTIONS.map(({value, label}) => ({value, label: gettext(label)}))}
            wrapperClassName={classnames(className)}
            formatOptionLabel={formatOptionLabel}
            onChange={onChange}/>
    );
};

export {LanguageSelector as TestableLanguageSelector};
export default LanguageSelector;
